/* ============================================================
   Archive Gama — theme JS
   ============================================================ */
(function () {
  'use strict';

  // --- Product card skeleton: clear shimmer once the first image is decoded ---
  document.querySelectorAll('[data-card-media]').forEach(function (media) {
    var img = media.querySelector('img');
    if (!img) { media.classList.remove('is-loading'); return; }
    if (img.complete && img.naturalWidth > 0) { media.classList.remove('is-loading'); return; }
    img.addEventListener('load',  function () { media.classList.remove('is-loading'); }, { once: true });
    img.addEventListener('error', function () { media.classList.remove('is-loading'); }, { once: true });
  });

  // --- Shuffle all-products grid (random order) ---
  document.querySelectorAll('[data-shuffle]').forEach(function (grid) {
    var items = Array.prototype.slice.call(grid.children);
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
    }
    items.forEach(function (el) { grid.appendChild(el); });
  });

  // --- Header shrink on scroll (panel sticks to header via CSS position:absolute) ---
  var headerEl = document.querySelector('.header');
  var shrinkTick = false;
  function syncHeader() {
    shrinkTick = false;
    if (!headerEl) return;
    var megaOpen = !!document.querySelector('.mega.is-open');
    headerEl.classList.toggle('is-scrolled', !megaOpen && window.pageYOffset > 20);
  }
  if (headerEl) {
    window.addEventListener('scroll', function () {
      if (!shrinkTick) { shrinkTick = true; window.requestAnimationFrame(syncHeader); }
    }, { passive: true });
    window.addEventListener('resize', syncHeader);
    syncHeader();
  }
  function startMegaTrack() { /* no-op: panel position handled by CSS */ }

  // Keep --mega-h in sync with the open panel height so the shared bg can
  // extend to cover header + panel as one continuous frosted surface.
  var shellEl = document.querySelector('[data-header-shell]');
  function syncMegaH() {
    if (!shellEl) return;
    var openPanel = shellEl.querySelector('.mega__panel.is-open');
    shellEl.style.setProperty('--mega-h', openPanel ? openPanel.offsetHeight + 'px' : '0px');
  }
  if (shellEl && 'ResizeObserver' in window) {
    var ro = new ResizeObserver(syncMegaH);
    shellEl.querySelectorAll('[data-mega-panel]').forEach(function (p) { ro.observe(p); });
  }
  window.addEventListener('resize', syncMegaH);

  // --- Mega menu (desktop dropdowns) ---
  // The panel now lives outside the header (a sibling) so both share one direct
  // backdrop-filter; pair each toggle with its panel by document order.
  var megas = document.querySelectorAll('[data-mega]');
  var megaPanelEls = document.querySelectorAll('[data-mega-panel]');
  function closeMegas(except) {
    megas.forEach(function (m, i) {
      if (m === except) return;
      m.classList.remove('is-open');
      var t = m.querySelector('[data-mega-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (megaPanelEls[i]) megaPanelEls[i].classList.remove('is-open');
    });
    syncMegaH();
    if (except == null) syncHeader();
  }
  megas.forEach(function (mega, i) {
    var toggle = mega.querySelector('[data-mega-toggle]');
    if (!toggle) return;
    var panel = megaPanelEls[i];
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = !mega.classList.contains('is-open');
      closeMegas(mega);
      mega.classList.toggle('is-open', willOpen);
      if (panel) panel.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      syncMegaH();
      if (willOpen) startMegaTrack(); else syncHeader();
    });
  });
  if (megas.length) {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mega]') && !e.target.closest('[data-mega-panel]')) closeMegas();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMegas();
    });
  }

  // --- Mobile drawer (hamburger menu) ---
  var drawer = document.querySelector('[data-drawer]');
  var drawerOpenBtn = document.querySelector('[data-drawer-open]');
  var drawerCloseBtn = drawer && drawer.querySelector('[data-drawer-close]');
  var drawerPanel = drawer && drawer.querySelector('.drawer__panel');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  if (drawerOpenBtn) drawerOpenBtn.addEventListener('click', openDrawer);
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeDrawer);
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (drawerPanel && !drawerPanel.contains(e.target)) closeDrawer();
    });
    // Close after tapping any nav link inside the drawer (but not the group toggle)
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeDrawer);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // --- Search overlay ---
  var searchOpen = document.querySelector('[data-search-open]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchBox = searchOverlay && searchOverlay.querySelector('.search-overlay__box');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    var input = searchOverlay.querySelector('input');
    if (input) setTimeout(function () { input.focus(); }, 60);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }

  if (searchOpen) searchOpen.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (searchBox && !searchBox.contains(e.target)) closeSearch();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  // --- Collection sidebar (mobile filter) ---
  var filterOpen = document.querySelector('[data-filter-open]');
  var filterOverlay = document.querySelector('[data-filter-overlay]');
  var collectionSidebar = document.querySelector('[data-collection-sidebar]');

  function openFilter() {
    if (collectionSidebar) collectionSidebar.classList.add('is-open');
    if (filterOverlay) filterOverlay.classList.add('is-active');
    document.body.classList.add('no-scroll');
  }
  function closeFilter() {
    if (collectionSidebar) collectionSidebar.classList.remove('is-open');
    if (filterOverlay) filterOverlay.classList.remove('is-active');
    document.body.classList.remove('no-scroll');
  }
  if (filterOpen) filterOpen.addEventListener('click', openFilter);
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilter);
  if (collectionSidebar) {
    collectionSidebar.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeFilter);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFilter();
  });

  // --- Product page: media stage (images + videos) ---
  var productStage = document.querySelector('[data-product-stage]');

  function activateProductMedia(id) {
    if (!productStage || id == null) return;
    id = String(id);
    productStage.querySelectorAll('.product__media').forEach(function (m) {
      var on = m.getAttribute('data-media-id') === id;
      m.classList.toggle('is-active', on);
      if (!on) {
        var vid = m.querySelector('video');
        if (vid && !vid.paused) vid.pause();
        var iframe = m.querySelector('iframe');
        if (iframe) iframe.src = iframe.src; // stop external video playback
      }
    });
    document.querySelectorAll('[data-product-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-media-id') === id);
    });
  }

  // --- Thumbnail carousel: drag to scroll + seamless infinite loop ---
  document.querySelectorAll('[data-thumb-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-thumb-track]');
    if (!track) return;

    var vertical = function () { return getComputedStyle(track).flexDirection === 'column'; };
    var fullSize = function () { return vertical() ? track.scrollHeight : track.scrollWidth; };
    var viewSize = function () { return vertical() ? track.clientHeight : track.clientWidth; };
    var getPos = function () { return vertical() ? track.scrollTop : track.scrollLeft; };
    var setPos = function (v) { if (vertical()) track.scrollTop = v; else track.scrollLeft = v; };

    var originals = Array.prototype.slice.call(track.children);
    var loopOn = false;
    var period = 0;

    function clearClones() {
      track.querySelectorAll('[data-clone]').forEach(function (c) { c.remove(); });
    }

    // Content offset of the first original = size of one full set (incl. its gap)
    function measurePeriod() {
      var tr = track.getBoundingClientRect();
      var fr = originals[0].getBoundingClientRect();
      return vertical()
        ? (fr.top - tr.top) + track.scrollTop
        : (fr.left - tr.left) + track.scrollLeft;
    }

    function setupLoop() {
      clearClones();
      loopOn = false;
      period = 0;
      setPos(0);
      if (fullSize() <= viewSize() + 2) return; // everything fits, no loop needed
      // Clone a full set before and after, preserving order (fragments avoid reversal)
      var beforeFrag = document.createDocumentFragment();
      var afterFrag = document.createDocumentFragment();
      originals.forEach(function (node) {
        var before = node.cloneNode(true); before.setAttribute('data-clone', '');
        var after = node.cloneNode(true); after.setAttribute('data-clone', '');
        beforeFrag.appendChild(before);
        afterFrag.appendChild(after);
      });
      track.insertBefore(beforeFrag, track.firstChild);
      track.appendChild(afterFrag);
      loopOn = true;
      period = measurePeriod();
      setPos(period); // start on the middle (original) set
    }

    function normalize() {
      if (!loopOn || !period) return;
      var p = getPos();
      if (p >= period * 2) setPos(p - period);
      else if (p < period) setPos(p + period);
    }
    // Scroll-fade: show while more thumbs remain past the end (bottom on
    // desktop / vertical, right edge on mobile / horizontal), hide at the end
    function updateFade() {
      var atEnd = vertical()
        ? track.scrollTop + track.clientHeight >= track.scrollHeight - 2
        : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      car.classList.toggle('has-more-below', !atEnd);
    }
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () { normalize(); updateFade(); });
    });

    // Mouse drag (touch already scrolls natively).
    // Capture the pointer only once a real drag starts, so a plain click
    // is never retargeted to the track and thumbnail selection keeps working.
    var down = false, start = 0, last = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false;
      start = last = vertical() ? e.clientY : e.clientX;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var cur = vertical() ? e.clientY : e.clientX;
      if (!moved) {
        if (Math.abs(cur - start) <= 4) return;
        moved = true;
        track.classList.add('is-dragging');
        track.setPointerCapture && track.setPointerCapture(e.pointerId);
      }
      var d = cur - last; last = cur;
      if (vertical()) track.scrollTop -= d; else track.scrollLeft -= d;
    });
    function endDrag() {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);
    // Swallow the click that follows a drag so it doesn't change the image
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { setupLoop(); updateFade(); }, 150);
    });
    setupLoop();
    updateFade();
  });

  // Activate media when a thumbnail (original or clone) is clicked
  if (productStage) {
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-product-thumb]');
      if (t) activateProductMedia(t.getAttribute('data-media-id'));
    });
  }

  // --- Quantity stepper (delegated so it survives cart section re-renders) ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qty-dec], [data-qty-inc]');
    if (!btn) return;
    var qty = btn.closest('[data-qty]');
    var input = qty && qty.querySelector('input');
    if (!input || input.disabled) return;
    var val = parseInt(input.value || '1', 10);
    if (btn.hasAttribute('data-qty-dec')) {
      input.value = Math.max(parseInt(input.min || '1', 10), val - 1);
    } else {
      var max = parseInt(input.getAttribute('max') || '999', 10);
      input.value = Math.min(max, val + 1);
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // --- See more (product description) ---
  var seeMore = document.querySelector('[data-see-more]');
  var desc = document.querySelector('[data-desc]');
  if (seeMore && desc) {
    seeMore.addEventListener('click', function () {
      var collapsed = desc.classList.toggle('product__desc--collapsed');
      seeMore.textContent = collapsed ? seeMore.dataset.more : seeMore.dataset.less;
    });
  }

  // --- Variant selection (linked to Shopify variants) ---
  (function () {
    var groups = Array.prototype.slice.call(document.querySelectorAll('[data-variants]'));
    if (!groups.length) return;

    var dataEl = document.querySelector('[data-product-variants]');
    var variants = null;
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = null; }
    }
    var idInput = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('.product__price');

    function selectedValues() {
      return groups.map(function (g) {
        var active = g.querySelector('.variant.is-active');
        return active ? active.getAttribute('data-value') : null;
      });
    }
    function matchVariant() {
      if (!variants) return null;
      var sel = selectedValues();
      return variants.filter(function (v) {
        for (var i = 0; i < sel.length; i++) {
          if (v.options[i] !== sel[i]) return false;
        }
        return true;
      })[0] || null;
    }
    var ctaEl = document.querySelector('[data-cta]');
    var qtyWrap = document.querySelector('[data-qty]');
    var qtyInput = qtyWrap && qtyWrap.querySelector('input');

    // Reflect the selected variant's stock: hide the buy buttons and show
    // "Sold out" (and lock the quantity) whenever the combination isn't buyable.
    function applyAvailability(v) {
      if (!variants) return; // no data: trust the server-rendered state
      var available = !!(v && v.available);
      if (ctaEl) {
        ctaEl.querySelectorAll('[data-buy-now], [data-add-to-cart]').forEach(function (b) {
          b.hidden = !available;
          b.disabled = !available;
        });
        var soldOut = ctaEl.querySelector('[data-sold-out]');
        if (soldOut) soldOut.hidden = available;
      }
      if (qtyWrap) qtyWrap.classList.toggle('is-disabled', !available);
      if (qtyInput) {
        qtyInput.disabled = !available;
        if (v && v.max != null) {
          var mx = parseInt(v.max, 10);
          if (mx >= 1) {
            qtyInput.setAttribute('max', mx);
            if (parseInt(qtyInput.value || '1', 10) > mx) qtyInput.value = mx;
          }
        }
      }
    }

    // Strike through option values (e.g. sizes) that have no buyable variant,
    // taking the other currently-selected options into account.
    function updateOptionAvailability() {
      if (!variants) return;
      var sel = selectedValues();
      groups.forEach(function (group, gi) {
        group.querySelectorAll('.variant').forEach(function (btn) {
          var val = btn.getAttribute('data-value');
          var ok = variants.some(function (v) {
            if (!v.available || v.options[gi] !== val) return false;
            for (var i = 0; i < sel.length; i++) {
              if (i === gi) continue;
              if (sel[i] != null && v.options[i] !== sel[i]) return false;
            }
            return true;
          });
          btn.classList.toggle('is-soldout', !ok);
        });
      });
    }

    function update() {
      var v = matchVariant();
      applyAvailability(v);
      updateOptionAvailability();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl && v.price) priceEl.textContent = v.price;
      if (v.media_id != null && typeof activateProductMedia === 'function') {
        activateProductMedia(v.media_id);
      }
    }

    groups.forEach(function (group) {
      group.querySelectorAll('.variant').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.variant').forEach(function (x) { x.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var label = group.querySelector('[data-selected-label]');
          if (label) label.textContent = btn.getAttribute('data-value');
          update();
        });
      });
    });

    // Sync state on load so sold-out selections are gated even before interaction.
    update();
  })();

  // --- Add to cart without leaving the page (like the reference: just bump the count) ---
  function setCartCount(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
      var badge = bubble.querySelector('.cart-bubble__count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-bubble__count';
          bubble.appendChild(badge);
        }
        badge.textContent = count;
        badge.classList.remove('is-bumped');
        void badge.offsetWidth; // restart animation
        badge.classList.add('is-bumped');
      } else if (badge) {
        badge.remove();
      }
    });
  }

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // "Buy now" (name="checkout") goes straight to checkout — leave it alone.
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();
      var btn = e.submitter;
      if (btn) btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCartCount(cart.item_count); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.classList.remove('is-loading'); });
    });
  });

  // --- Cart: remove item / change quantity without reloading the page ---
  (function () {
    var cartRoot = document.querySelector('.cart-wrap');
    if (!cartRoot) return;
    var section = cartRoot.closest('.shopify-section');
    var sectionId = section ? section.id.replace('shopify-section-', '') : null;
    var busy = false;
    var DEST_KEY = 'archivegama:ship-dest';

    function getDest() {
      try {
        var v = localStorage.getItem(DEST_KEY);
        return v === 'intl' ? 'intl' : 'us';
      } catch (e) { return 'us'; }
    }
    function setDest(v) {
      try { localStorage.setItem(DEST_KEY, v); } catch (e) {}
    }
    function applyDest(root) {
      var summary = (root || cartRoot).querySelector('[data-cart-summary]');
      if (!summary) return;
      var dest = getDest();
      summary.setAttribute('data-active-dest', dest);
      var btns = summary.querySelectorAll('.cart__dest-btn');
      btns.forEach(function (b) {
        var active = b.getAttribute('data-dest') === dest;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    applyDest();
    cartRoot.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart__dest-btn');
      if (!btn) return;
      e.preventDefault();
      var dest = btn.getAttribute('data-dest');
      if (dest !== 'us' && dest !== 'intl') return;
      setDest(dest);
      applyDest();
    });

    function fullReplace(freshRoot) {
      cartRoot.innerHTML = freshRoot.innerHTML;
      applyDest();
    }

    // Surgical update: keep the existing nodes (so CSS transitions fire) and patch
    // only the bits that changed. Falls back to full replace when the structure
    // shifts (empty <-> non-empty, lines added).
    function patch(freshRoot) {
      var wasEmpty = !!cartRoot.querySelector('.cart__empty');
      var willBeEmpty = !!freshRoot.querySelector('.cart__empty');
      if (wasEmpty !== willBeEmpty) { fullReplace(freshRoot); return; }
      if (willBeEmpty) { fullReplace(freshRoot); return; }

      // Header item count
      var freshMeta = freshRoot.querySelector('.cart__head .meta');
      var liveMeta = cartRoot.querySelector('.cart__head .meta');
      if (freshMeta && liveMeta) liveMeta.innerHTML = freshMeta.innerHTML;

      // Per-line: quantity input + line price
      var freshItems = freshRoot.querySelectorAll('.cart__item');
      var liveItems = cartRoot.querySelectorAll('.cart__item:not(.is-removing)');
      if (freshItems.length !== liveItems.length) { fullReplace(freshRoot); return; }
      freshItems.forEach(function (freshItem, i) {
        var liveItem = liveItems[i];
        if (!liveItem) return;
        var freshPrice = freshItem.querySelector('.cart__item-price');
        var livePrice = liveItem.querySelector('.cart__item-price');
        if (freshPrice && livePrice) livePrice.innerHTML = freshPrice.innerHTML;
        var freshInput = freshItem.querySelector('input[name="updates[]"]');
        var liveInput = liveItem.querySelector('input[name="updates[]"]');
        if (freshInput && liveInput && document.activeElement !== liveInput) {
          liveInput.value = freshInput.value;
        }
      });

      // Progress bar — keep the same <span> so width transitions
      var freshProgress = freshRoot.querySelector('.cart__progress');
      var liveProgress = cartRoot.querySelector('.cart__progress');
      if (freshProgress && liveProgress) {
        liveProgress.className = freshProgress.className;
        var freshBar = freshProgress.querySelector('span');
        var liveBar = liveProgress.querySelector('span');
        if (freshBar && liveBar) liveBar.style.width = freshBar.style.width;
      }
      var freshLabel = freshRoot.querySelector('.cart__progress-label');
      var liveLabel = cartRoot.querySelector('.cart__progress-label');
      if (freshLabel && liveLabel) liveLabel.innerHTML = freshLabel.innerHTML;

      // Price details breakdown
      var freshDetails = freshRoot.querySelector('.cart__details');
      var liveDetails = cartRoot.querySelector('.cart__details');
      if (freshDetails && liveDetails) liveDetails.innerHTML = freshDetails.innerHTML;

      // Total
      var freshTotal = freshRoot.querySelector('.cart__total');
      var liveTotal = cartRoot.querySelector('.cart__total');
      if (freshTotal && liveTotal) liveTotal.innerHTML = freshTotal.innerHTML;

      // Re-apply selected shipping destination after re-render
      applyDest();
    }

    function rerender(html) {
      if (!html) { window.location.reload(); return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.cart-wrap');
      if (!fresh) { window.location.reload(); return; }
      patch(fresh);
    }

    function changeLine(line, quantity, optimisticItem) {
      if (busy) return;
      busy = true;
      cartRoot.classList.add('is-busy');
      var body = { line: line, quantity: quantity };
      if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          setCartCount(cart.item_count);
          if (optimisticItem && optimisticItem.parentNode) optimisticItem.parentNode.removeChild(optimisticItem);
          if (sectionId && cart.sections && cart.sections[sectionId]) rerender(cart.sections[sectionId]);
          else window.location.reload();
        })
        .catch(function () {
          if (optimisticItem) optimisticItem.classList.remove('is-removing');
          window.location.reload();
        })
        .then(function () { busy = false; cartRoot.classList.remove('is-busy'); });
    }

    cartRoot.addEventListener('click', function (e) {
      var rm = e.target.closest('.cart__item-remove');
      if (!rm) return;
      e.preventDefault();
      var line = parseInt(rm.getAttribute('data-line'), 10);
      if (!line) return;
      var item = rm.closest('.cart__item');
      if (item) item.classList.add('is-removing');
      changeLine(line, 0, item);
    });

    cartRoot.addEventListener('change', function (e) {
      var input = e.target.closest('input[name="updates[]"]');
      if (!input) return;
      var line = parseInt(input.getAttribute('data-line'), 10);
      var qty = Math.max(0, parseInt(input.value || '0', 10));
      if (!line) return;
      if (qty === 0) {
        var item = input.closest('.cart__item');
        if (item) item.classList.add('is-removing');
        changeLine(line, 0, item);
      } else {
        changeLine(line, qty);
      }
    });
  })();

  // Brand marquee is driven by CSS animation (see .brands__track).

  // --- Recommendations carousel (seamless infinite loop) ---
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-carousel-track]');
    if (!track) return;
    var scope = car.closest('.recommendations') || car.parentElement || document;
    var prev = scope.querySelector('[data-carousel-prev]');
    var next = scope.querySelector('[data-carousel-next]');

    var originals = Array.prototype.slice.call(track.children);
    var loopOn = false;
    var period = 0;

    function clearClones() {
      track.querySelectorAll('[data-clone]').forEach(function (c) { c.remove(); });
    }
    function measurePeriod() {
      var tr = track.getBoundingClientRect();
      var fr = originals[0].getBoundingClientRect();
      return (fr.left - tr.left) + track.scrollLeft;
    }
    function setupLoop() {
      clearClones();
      loopOn = false;
      period = 0;
      track.scrollLeft = 0;
      if (!originals.length || track.scrollWidth <= track.clientWidth + 2) return;
      var beforeFrag = document.createDocumentFragment();
      var afterFrag = document.createDocumentFragment();
      originals.forEach(function (node) {
        var b = node.cloneNode(true); b.setAttribute('data-clone', '');
        var a = node.cloneNode(true); a.setAttribute('data-clone', '');
        beforeFrag.appendChild(b);
        afterFrag.appendChild(a);
      });
      track.insertBefore(beforeFrag, track.firstChild);
      track.appendChild(afterFrag);
      loopOn = true;
      period = measurePeriod();
      track.scrollLeft = period;
    }
    function normalize() {
      if (!loopOn || !period) return;
      var p = track.scrollLeft;
      if (p >= period * 2) track.scrollLeft = p - period;
      else if (p < period * 0.5) track.scrollLeft = p + period;
    }
    var idleT;
    track.addEventListener('scroll', function () {
      clearTimeout(idleT);
      idleT = setTimeout(normalize, 120);
    });

    function step() {
      var first = track.querySelector('.product-card');
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      return first ? first.getBoundingClientRect().width + gap : 280;
    }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(setupLoop, 150);
    });
    setupLoop();
  });

  // --- Product card image galleries (swipe / drag) ---
  document.querySelectorAll('[data-card-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-card-track]');
    if (!track) return;
    var dots = gallery.querySelectorAll('[data-card-dots] .product-card__dot');
    var link = gallery.closest('.product-card');

    function updateDots() {
      if (!dots.length) return;
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateDots);
    });

    // Mouse drag for desktop (touch already scrolls natively)
    var down = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    function endDrag(e) {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      if (moved) {
        var w = track.clientWidth;
        track.scrollTo({ left: Math.round(track.scrollLeft / w) * w, behavior: 'smooth' });
      }
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);

    // Prev/next arrows (desktop)
    var prevBtn = gallery.querySelector('[data-card-prev]');
    var nextBtn = gallery.querySelector('[data-card-next]');
    function go(dir) {
      var w = track.clientWidth;
      var count = track.children.length;
      var idx = Math.round(track.scrollLeft / w) + dir;
      if (idx > count - 1) idx = 0;
      else if (idx < 0) idx = count - 1;
      track.scrollTo({ left: idx * w, behavior: 'smooth' });
    }
    function arrow(btn, dir) {
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(dir);
      });
    }
    arrow(prevBtn, -1);
    arrow(nextBtn, 1);

    // Touch swipe wrap-around at the edges (mobile)
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var w = track.clientWidth;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) < 40) return;
      var maxScroll = track.scrollWidth - w;
      if (dx < 0 && track.scrollLeft >= maxScroll - 2) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (dx > 0 && track.scrollLeft <= 2) {
        track.scrollTo({ left: maxScroll, behavior: 'smooth' });
      }
    }, { passive: true });

    // Prevent navigation when the user dragged instead of clicking
    if (link) {
      link.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          moved = false;
        }
      });
    }
  });
})();
